























































































































































import { Component, Vue } from 'vue-property-decorator'
import Advert from '@/components/Advert/Advert.vue'
import Advert2 from '@/components/Advert/Advert2.vue'
import Advert3 from '@/components/Advert/Advert3.vue'
import Advert4 from '@/components/Advert/Advert4.vue'
import Advert5 from '@/components/Advert/Advert5.vue'
import Advert6 from '@/components/Advert/Advert6.vue'

@Component({ components: { Advert, Advert2, Advert3, Advert4, Advert5, Advert6 } })
export default class Product extends Vue {

  audio: HTMLAudioElement | null = null
  component: HTMLAudioElement | null = null

  autohideTrue: boolean = false
  loaded: boolean = false // 页面是否已经加载完成
  staticPath: string = 'https://s.doumiao9.com/official'
  videoLink: string = '' // 视频链接
  scrollY: number = 0
  videoName: string = ''
  videoObj: any = {
    'jbg-03' : '<p>将算珠在大脑中转化成数字的过程，在软件中设置影像的位数和速度，速度的数值越小，珠像消失的越快，口述回答珠像并判断是否正确，这种训练可以代替闪卡训练，用软件训练建议从0.8秒开始训练，以0.2秒的时间递减。</p>',
    'jbg-01' : '<p>将听到的数字转化为算盘上的珠像的一种训练方法，一是有助于提高拨珠的频率，二是加深珠像在大脑中的清晰程度。在软件中根据学生的情况设置位数，读题方式可以选择单读（如25，读二五）或者连读（如25，读二十五），速度的快慢及停留时间长短均可调节，速度越快对于拨珠速度要求越高，前期可以从中速开始训练，再逐渐提高速度，选择读拨去可以掌握拨珠的频率。</p>',
    'jbg-04' : '<p>通过多种游戏的形式，让学生更快记住凑数以及补数等（5的分合、10的分合、24的分合、100的分合），同时增加游戏形式用以增加课堂趣味性。软件中设置有初中高三个等级难度，教练师可以按需选择。</p>',
    'jbg-05' : '<p>数码的记忆是看心算的基础，我们可以将看到的数字让学生在数码消失之后口述重复一遍，数码位数根据学生记忆能力逐位递增，这样既能培养学生的瞬间记忆能力，同时也能促进大脑智能的发展。同时，我们也可以提前准备答题卡，选择不显示答案，题目完成后统一查看测试成绩，做题过程中，可以通过点击当前界面左右方的小三角符号查看上一题或下一题。</p>',
    'jbg-02' : '将影响训练（闪卡训练）转换成游戏形式，每一个游戏都有自己的训练重点，例如：听数译珠、看珠译数等等，教练师可以选择训练位数及题目数量，让学生上课更有积极性，在游戏中不知不觉就已经掌握了知识点。',
    'jbg-06' : '将听到的数码写下来，速度由慢到快，既训练学生记数字的能力，也提高学生写数码的速度。在软件中根据学生情况设置位数、单读（如25，读二五）或者连读（如25，读二十五）的读题方式，读题速度和换题速度的数值越小，对于写数码的要求就越高。',
    'zzct-03' : '<p>大脑迅速将滚动或不滚动出现的一串数字转为脑中的珠像，这个过程主要锻炼了学生视觉追踪能力，视觉追踪能力差的话，容易跳数字或者不知道自己算到哪儿了，所以很难快速准确的捕捉到屏幕数字的。</p><p>学生刚开始心算的时候，速度慢就可以选择不滚动，或者把滚动时长调大一些，对于学习水平比较高的，就可以把滚动时长调小，最快可以调到0.1秒，对于心算速度非常快的学员，用这个可以更大的提高和挖掘他们的潜能。滚动时长、答题时间均可自助选择。</p><p>滚动方式可以选择横竖或者竖式，用以和小学横式衔接。</p><p>出题题型可以选择连加、加减、综合（纯加和加减题随机出现）、连减。首笔位数及小数点位数可自由设置。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。</p>',
    'zzct-02' : '<p>大脑迅速将听到的数字转为脑中的珠像，这个过程锻炼了学生听觉反应力，学生需要快速说出答案，同时也锻炼了学员的听说结合能力。这也是学习加减法时常用来训练心算的项目，对于注意力不容易的集中的学生来说，听心算更有利于让他专注心算。</p><p>听心算语速可以调节，分为慢-中-快-特快。同时间隔时长也会影响报题速度。一般刚开始的小朋友速度都比较慢，用中速较多，学了一段时间后，都是快速或者特快速，因为就是这两个速度都不算很快，哪怕把间隔时长调整到0，也没有闪电算和看心算速度快，因此，这个对大多数学生来说听心算都是简单一点的。上面有个隐藏功能，就是可以把数字隐藏起来，这个就更加考验学员的听反应力了，如果是显示题目，学员可听也可看，相对来说就更加容易捕捉到信息。<p>出题题型可以选择连加、加减、综合（纯加和加减题随机出现）、连减。首笔位数及小数点位数可自由设置。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。</p>',
    'zzct-06' : '<p>大脑迅速将闪过的数字转为脑中的珠像，这个过程锻炼了学生视觉反应力，视觉分辨力。</p><p>可选择影像笔数（即珠像笔数）、是否一脑双算、停留时长、间隔时长、（解答速度）答题时长等参数。</p><p>闪电心算加入干扰模式，很好的锻炼了学生抗干扰能力，让学生在一堆杂乱的数字里面排除无用信息获取有效的数字来进行计算。干扰模式分为：无干扰、数字干扰、障碍干扰、内放射干扰、外放射干扰形式。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。</p>',
    'jm-04' : '大脑迅速将看到的题目在算盘上拨出来，这个过程锻炼了学生视觉敏感度，因为他需要将眼睛看到的数字双手在算盘上拨出正确的答案，同时也锻炼了学员手眼脑协调一致性。看珠算就只需要设置好笔数和位数，就可以点击开始做题，对比让学员做纸质的珠算练习，这个做一题就可以检查一题，做对了还有“答对了”的音效，学员听到更加有信心和激情去完成更多练习。答错了，学员就可以马上去纠正，老师及时发现他们的问题出现在哪里。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。',
    'zzct-01' : '<p>（1）自助乘算：自由设置被乘数和乘数的位数，因数的小数点位数可以指定，也可以随机。</p> <p>（2）一口清：被乘数可以任意选择位数，且小数点位数可指定，也可以随机；乘数可以选择某一个（也可多选）固定一位数。同时通过被乘数与乘数中间的转换符号可以调整一位数乘数的位置。用作一位数的乘法教学环节。</p> <p>（3）多笔乘算：有最小位数、最大位数、笔数、小数点四个自助选项，可以根据与小学的衔接需要自由出题。</p>',
    'zzct-07' : '<p>（1）自助除算1：被除数位数、除数位数、小数点位数可以自助设定。商可选除尽与除不尽。注：此栏目里出来的一套题里，被除数和除数的位数都是相同，商的位数可能不同。</p><p>（2）自助除算2：除数的位数、商的位数、小数点的位数可以自助设定。注：此栏目里出来的一套题里，除数和商的位数都是相同，被除数的位数可能不同。</p><p>（3）一口清：被除数的位数、小数点的位数可以自助设定，除数为固定一位数（一位数可多选）。用作一位数的除法教学环节。</p><p>（4）估首商：被除数的位数、除数的位数可自由设定，也可以选择除数是1开头的特殊估商题。答案只需要输入第一位商几即可，不用计算答案。用以估商教学环节。</p>',
    'kj-01' : '口诀里面有加减的口诀分类，根据需要选择相对应的口诀，点进一个口诀里面细分了每一个小口诀，每个口诀里面都有不同的题型，可以让小朋友直观地看到拨珠指法，对于有些小朋友混口诀的，老师也可以用来给小朋友判断题型。',
    'kj-02' : '大脑迅速将滚动或不滚动出现的一串数字转为脑中的珠像，这个过程主要锻炼了学生视觉追踪能力，视觉追踪能力差的话，容易跳数字或者不知道自己算到哪儿了，所以很难快速准确的捕捉到屏幕数字的。学生刚开始心算的时候，速度慢就可以选择不滚动，或者把滚动时长调大一些，对于学习水平比较高的，就可以把滚动时长调小，最快可以调到0.1秒，对于心算速度非常快的学员，用这个可以更大的提高和挖掘他们的潜能。滚动时长、答题时间均可自助选择。',
    'kj-05' : '大脑迅速将听到的数字转为脑中的珠像，这个过程锻炼了学生听觉反应力，学生需要快速说出答案，同时也锻炼了学员的听说结合能力。这也是学习加减法时常用来训练心算的项目，对于注意力不容易的集中的学生来说，听心算更有利于让他专注心算。听心算语速可以调节，分为慢-中-快-特快。同时间隔时长也会影响报题速度。一般刚开始的小朋友速度都比较慢，用中速较多，学了一段时间后，都是快速或者特快速，因为就是这两个速度都不算很快，哪怕把间隔时长调整到0，也没有闪电算和看心算速度快，因此，这个对大多数学生来说听心算都是简单一点的。上面有个隐藏功能，就是可以把数字隐藏起来，这个就更加考验学员的听反应力了，如果是显示题目，学员可听也可看，相对来说就更加容易捕捉到信息。',
    'kj-04' : '大脑迅速将闪过的数字转为脑中的珠像，这个过程锻炼了学生视觉反应力，视觉分辨力。可选择影像笔数（即珠像笔数）、是否一脑双算、停留时长、间隔时长、（解答速度）答题时长等参数。闪电心算加入干扰模式，很好的锻炼了学生抗干扰能力，让学生在一堆杂乱的数字里面排除无用信息获取有效的数字来进行计算。干扰模式分为：无干扰、数字干扰、障碍干扰、内放射干扰、外放射干扰形式。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。',
    'kj-03' : '大脑迅速将看到的题目在算盘上拨出来，这个过程锻炼了学生视觉敏感度，因为他需要将眼睛看到的数字双手在算盘上拨出正确的答案，同时也锻炼了学员手眼脑协调一致性。看珠算就只需要设置好笔数和位数，就可以点击开始做题，对比让学员做纸质的珠算练习，这个做一题就可以检查一题，做对了还有“答对了”的音效，学员听到更加有信心和激情去完成更多练习。答错了，学员就可以马上去纠正，老师及时发现他们的问题出现在哪里。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。',
    'jbxl-01' : '级别训练和能手训练都有两个栏目，分别是（级别/能手）鉴定和（级别/能手）专项，（级别/能手）鉴定这里有4个版本，当前国内主流都是新少儿版本，豆苗的级别系统都严格按照中珠协的出题标准，上下左右不重复，大小数均衡，平均数均衡等过滤；保证每一份级别题目出来都是标准，同一级别的题目难度系数都是一样，保证每一个学生公平公正，选择（级别/能手）专项是训练该级别的特定题型，（级别/能手）专项题，如学到3级，学生需要专门练习带小数乘法，那么我们就可以选择（级别/能手）专项，然后选择带小数的乘法！需要注意的是加减和乘除不能同时选择。能手训练也有两个栏目， 熟练运用口诀进行练习，公平公正的出题系统让学生更好的训练该级别的特定题型。',
    'jbxl-02' : '大脑迅速将滚动或不滚动出现的一串数字转为脑中的珠像，这个过程主要锻炼了学生视觉追踪能力，视觉追踪能力差的话，容易跳数字或者不知道自己算到哪儿了，所以很难快速准确的捕捉到屏幕数字的。学生刚开始心算的时候，速度慢就可以选择不滚动，或者把滚动时长调大一些，对于学习水平比较高的，就可以把滚动时长调小，最快可以调到0.1秒，对于心算速度非常快的学员，用这个可以更大的提高和挖掘他们的潜能。滚动时长、答题时间均可自助选择。',
    'jbxl-05' : '大脑迅速将听到的数字转为脑中的珠像，这个过程锻炼了学生听觉反应力，学生需要快速说出答案，同时也锻炼了学员的听说结合能力。这也是学习加减法时常用来训练心算的项目，对于注意力不容易的集中的学生来说，听心算更有利于让他专注心算。听心算语速可以调节，分为慢-中-快-特快。同时间隔时长也会影响报题速度。一般刚开始的小朋友速度都比较慢，用中速较多，学了一段时间后，都是快速或者特快速，因为就是这两个速度都不算很快，哪怕把间隔时长调整到0，也没有闪电算和看心算速度快，因此，这个对大多数学生来说听心算都是简单一点的。上面有个隐藏功能，就是可以把数字隐藏起来，这个就更加考验学员的听反应力了，如果是显示题目，学员可听也可看，相对来说就更加容易捕捉到信息。',
    'jbxl-04' : '<p>大脑迅速将闪过的数字转为脑中的珠像，这个过程锻炼了学生视觉反应力，视觉分辨力。</p><p>可选择影像笔数（即珠像笔数）、是否一脑双算、停留时长、间隔时长、（解答速度）答题时长等参数。</p><p>闪电心算加入干扰模式，很好的锻炼了学生抗干扰能力，让学生在一堆杂乱的数字里面排除无用信息获取有效的数字来进行计算。干扰模式分为：无干扰、数字干扰、障碍干扰、内放射干扰、外放射干扰形式。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。</p>',
    'jbxl-03' : '大脑迅速将看到的题目在算盘上拨出来，这个过程锻炼了学生视觉敏感度，因为他需要将眼睛看到的数字双手在算盘上拨出正确的答案，同时也锻炼了学员手眼脑协调一致性。看珠算就只需要设置好笔数和位数，就可以点击开始做题，对比让学员做纸质的珠算练习，这个做一题就可以检查一题，做对了还有“答对了”的音效，学员听到更加有信心和激情去完成更多练习。答错了，学员就可以马上去纠正，老师及时发现他们的问题出现在哪里。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。',
    'nsxl-01' : '级别训练和能手训练都有两个栏目，分别是（级别/能手）鉴定和（级别/能手）专项，（级别/能手）鉴定这里有4个版本，当前国内主流都是新少儿版本，豆苗的级别系统都严格按照中珠协的出题标准，上下左右不重复，大小数均衡，平均数均衡等过滤；保证每一份级别题目出来都是标准，同一级别的题目难度系数都是一样，保证每一个学生公平公正，选择（级别/能手）专项是训练该级别的特定题型，（级别/能手）专项题，如学到3级，学生需要专门练习带小数乘法，那么我们就可以选择（级别/能手）专项，然后选择带小数的乘法！需要注意的是加减和乘除不能同时选择。能手训练也有两个栏目， 熟练运用口诀进行练习，公平公正的出题系统让学生更好的训练该级别的特定题型。',
    'nsxl-02' : '大脑迅速将滚动或不滚动出现的一串数字转为脑中的珠像，这个过程主要锻炼了学生视觉追踪能力，视觉追踪能力差的话，容易跳数字或者不知道自己算到哪儿了，所以很难快速准确的捕捉到屏幕数字的。学生刚开始心算的时候，速度慢就可以选择不滚动，或者把滚动时长调大一些，对于学习水平比较高的，就可以把滚动时长调小，最快可以调到0.1秒，对于心算速度非常快的学员，用这个可以更大的提高和挖掘他们的潜能。滚动时长、答题时间均可自助选择。',
    'nsxl-05' : '大脑迅速将听到的数字转为脑中的珠像，这个过程锻炼了学生听觉反应力，学生需要快速说出答案，同时也锻炼了学员的听说结合能力。这也是学习加减法时常用来训练心算的项目，对于注意力不容易的集中的学生来说，听心算更有利于让他专注心算。<p>听心算语速可以调节，分为慢-中-快-特快。同时间隔时长也会影响报题速度。一般刚开始的小朋友速度都比较慢，用中速较多，学了一段时间后，都是快速或者特快速，因为就是这两个速度都不算很快，哪怕把间隔时长调整到0，也没有闪电算和看心算速度快，因此，这个对大多数学生来说听心算都是简单一点的。上面有个隐藏功能，就是可以把数字隐藏起来，这个就更加考验学员的听反应力了，如果是显示题目，学员可听也可看，相对来说就更加容易捕捉到信息。</p>',
    'nsxl-04' : '<p>大脑迅速将闪过的数字转为脑中的珠像，这个过程锻炼了学生视觉反应力，视觉分辨力。</p><p>可选择影像笔数（即珠像笔数）、是否一脑双算、停留时长、间隔时长、（解答速度）答题时长等参数。</p><p>闪电心算加入干扰模式，很好的锻炼了学生抗干扰能力，让学生在一堆杂乱的数字里面排除无用信息获取有效的数字来进行计算。干扰模式分为：无干扰、数字干扰、障碍干扰、内放射干扰、外放射干扰形式。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。</p>',
    'nsxl-03' : '大脑迅速将看到的题目在算盘上拨出来，这个过程锻炼了学生视觉敏感度，因为他需要将眼睛看到的数字双手在算盘上拨出正确的答案，同时也锻炼了学员手眼脑协调一致性。看珠算就只需要设置好笔数和位数，就可以点击开始做题，对比让学员做纸质的珠算练习，这个做一题就可以检查一题，做对了还有“答对了”的音效，学员听到更加有信心和激情去完成更多练习。答错了，学员就可以马上去纠正，老师及时发现他们的问题出现在哪里。右上角音乐及耳朵图标可以选择音乐干扰和杂音干扰。',
    'qt-02' : '<p>根据指法演示提高珠算的水平，强化基本功的练习，里面有4个指法可以选择,声音速度可以根据需求选择。</p><p>1、例题讲解：例题讲解可以自选例题，也就是自己出题在算盘上演示，还可以选择基础口诀和级别的题目类型来进行指法演示，目的是为了让老师在讲解例题的时候可以可以直观的看到在算盘上的拨珠指法，通过生动形象的演示提高学习兴趣。</p><p>2、打百子：打百子里面有四个栏目，分别是顺百子，逆百子，先奇后偶，先偶后奇，可以选择百子加或百子减，基础数是起拨数，百子开始数是第一个开始加或减的数，百子终止数是加或减到最后一个的数字，速度有慢，中，快，特快，可以根据自己得需要进行选择。这里的听打和看打的目的是训练学生听，看打百子的能力，可以锻炼小朋友的反应力和观察力，也可以让小朋友清楚地知道打百子的计算结果，还可以检查小朋友哪个口诀不熟练，老师就可以对症下药给学生加强训练。</p><p>3、定数加减：定数加和定数减可以选择听打和看打，定数可以选择需要练习加或减的定数，次数是加或减多少次，起始数是起拨数，速度可以根据自己的需要选择。定数加减的目的是训练学生听，看打定数的能力，能锻炼小朋友的反应力，观察力和拨珠能力，让小朋友跟拨，这是一项基本功的训练，训练学生的口诀区分,拨珠速度等,最后输入答案,会提示是否答对,答错后有重新或者继续挑战的机会,也可以选择指法演示,在没有老师的在场教学的情况下依然可以给演示正确的指法，可以清楚的知道计算结果。</p><p>4、百子：百子有百子加和百子减，其中有四个栏目，分别是顺百子，逆百子，先奇后偶，先偶后奇，起始数是起拨数，百子开始数是第一个开始加或减的数，百子终止数是加或减到最后一个的数字，百子指法的演示，能熟练的掌握珠算的口诀，口诀不熟练的学生可以跟拨，针对性的练习，达到预期的训练目的。</p><p>5、定数：定数可以选择定数加和定数减，定数可以选择需要练习加或减的定数，相加/减次数可以自行选择，起始数是起拨数，定数的目的是为了让学生可以更好的区分口诀，在课堂堂上老师可以灵活运用给学生们进行练习。</p><p>6、口诀：口诀里面有加减的口诀分类，根据需要选择相对应的口诀，点进一个口诀里面细分了每一个小口诀，每个口诀里面都有不同的题型，可以让小朋友直观地看到拨珠指法，对于有些小朋友混口诀的，老师也可以用来给小朋友判断题型。</p>',
    'qt-04' : '珠算训练可以更换背景，更换音乐和干扰音，还可以静音，根据需要设置时长，目的是为了让学生有时间观念，在规定的时间做题或者静坐训练等，让学生在规定时间内完成某一项练习，合理安排训练时间，提高训练效率，老师可以用多种办法来利用这个珠算训练来丰富课堂。',
    'qt-06' : '启智游戏真正实现”玩中学,学中玩”的教育理念,其中包含了舒尔特超级记忆、魔法思维等训练方式,让学生们思维敏捷,记忆超群。启智游戏里的每个游戏锻炼学生的目的不同，趣味性很强，通过游戏可以让学生养成一个细心专注的好习惯，培养学生的观察力，推理能力，反应能力等等。老师可以根据情况来选择，进一步发展儿童的智力，提高儿童的整体素质，老师可以在下课之前作为奖励给小朋友玩，小朋友上完一节课也不会觉得枯燥，可以培养浓厚的学习兴趣。',
    'jbg-08' : '主要用来加深脑珠像，是听心算的基础，把听到的数珠描述语，在脑中迅速反应出算珠影像的过程。我们在软件中可以根据学生情况设置位数、读题速度等，读题的顺序可以顺序、倒序或者随机（档位随机读取），这对于加深脑影像很有帮助。',
    'jbg-09' : '用以快速辨认档位及拓宽脑影像。在软件中根据学生的情况设置位数以及停留的时间和解题速度，时间和速度的数值越小对快速记忆的要求越高，刚开始训练可从0.8秒开始训练，以0.2秒的时间递减。',
    'jbg-07' : '数码书写的快慢、准确与清晰程度，直接影响到珠心算的测试成绩。有的学生算题快但是写答案慢，这对比赛来说是很耽误时间的，所以数码书写非常重要，数码书写的笔顺，比如，8、 9、 0三个数字都是逆时针起笔书写的，总会有的学生写反，还有7写的像2,9写的像4,6写的像0,0写的像6等等，还有的学生写数码连笔，这些问题都要在一开始就严格要求，规范书写。豆苗软件的数字示范就能起到很好的示范性作用。',
    'zzct-05' : '红包雨有最大位数和最小位数的参数设置，笔数可以手动输入，题型有连加，加减，连减和综合，速度和题数可以自行选择，红包雨画面会掉下很多干扰物和红包，小朋友需要捕捉到红包上的数字来进行计算，可以增强小朋友的视觉捕捉能力和快速计算的反应力，掉下的干扰物也可以锻炼小朋友的抗干扰能力。',
    'jm-01' : '水果干扰有最大位数和最小位数的参数设置，笔数可以手动输入，题型有连加，加减，连减和综合，速度和题数可以自行选择，显示答案可以选择是和否，画面会出现很多水果来进行干扰，水果当中会随机出现数字，小朋友需要快速的捕捉到数字并计算出答案，孩子可以通过这种生动形象的计算方式更加的喜欢心算，这种游戏的干扰模式小朋友也会很喜欢的。',
    'jm-02' : '心算训练可以清晰的锻炼小朋友在大脑中的影像，把计算的过程用影像更清楚的呈现出来，增强了空间记忆和专注力的能力，加减乘除法都可以用心算训练，右上角的设置还有指法，算盘样式，拨珠速度都可以选择。',
    'jm-03' : '根据指法演示提高珠算的水平，强化基本功的练习，里面有指法可以选择, 还有音乐和噪音的干扰，目的是为了让老师在讲解例题的时候可以直观的看到在算盘上的拨珠指法，通过生动形象的演示提高学习兴趣。',
    'jm-05' : '贪吃精灵有最大位数和最小位数的参数设置，笔数可以手动输入，题型有连加，加减，连减和综合，速度和题数可以自行选择，小精灵会快速的吃掉下一个亮起的数字，小朋友需要快速的计算出答案并进行下一步的计算，考验小朋友快速的反应力和记忆力，这些游戏都是知识的深入浅出，让孩子轻轻松松，不知不自觉掌握知识，爱上学习。',
    'qt-07' : '级别鉴定和能手鉴定都有两个栏目，分别是（级别/能手）鉴定和（级别/能手）专项，（级别/能手）鉴定这里有4个版本，当前国内主流都是新少儿版本，豆苗的级别系统都严格按照中珠协的出题标准，上下左右不重复，大小数均衡，平均数均衡等过滤；保证每一份级别题目出来都是标准，同一级别的题目难度系数都是一样，保证每一个学生公平公正，选择（级别/能手）专项是训练该级别的特定题型，（级别/能手）专项题，如学到3级，学生需要专门练习带小数乘法，那么我们就可以选择（级别/能手）专项，然后选择带小数的乘法！需要注意的是加减和乘除不能同时选择。能手训练也有两个栏目， 熟练运用口诀进行练习，公平公正的出题系统让学生更好的训练该级别的特定题型。'
  }
  to (path: string) {
    Lib.router.push(path)
  }
  back () {
    Lib.router.go(-1)
  }
  download (path: string) {
    window.open(path)
  }
  created () {
    this.loaded = true
  }
  videoPlay (link: string) {
    this.scrollY = window.scrollY
    window.scrollTo(0,0)
    let popup = document.querySelector('.product-video-popup') as HTMLDivElement
    let video = document.querySelector('.product-introduce-video') as HTMLVideoElement
    let text = document.querySelector('.product-video-jieshao') as HTMLDivElement
    // 清空描述文本，避免显示之前的内容
    text.innerHTML = ''
    if (link.indexOf('ketang') !== -1) {
      console.log('link' ,link.split('.')[0].split('/')[2].split('-')[2] + '-' + link.split('.')[0].split('/')[2].split('-')[3])
      let type: string = link.split('.')[0].split('/')[2].split('-')[2] + '-' + link.split('.')[0].split('/')[2].split('-')[3]
      // this.videoName = this.videoObj[type]
      text.innerHTML = this.videoObj[type]
      // console.log(div)
      this.audio = document.querySelector('.app-music-player-audio')
      this.component = document.querySelector('.component-app-music-player')
      if (this.audio) {
        // 获取当前用户是否主动停止播放
        if (this.audio.paused) {
          sessionStorage.appMusicState = 'true'
        } else {
          sessionStorage.appMusicState = 'false'
        }
        // 设置当前的播放的的时间
        sessionStorage.clickcount = Number(this.audio.currentTime)
        // 暂停
        this.audio.pause()
        if (this.component) {
          this.component.classList.add('paused')
        }
      }
    }
    // 珠心算Ai学生端和管理端使用外部视频地址
    if (link.indexOf('xingsuan') !== -1) {
      video.src = 'https://s.doumiao9.com/official/media/product-xsstudent-intro.mp4'
    } else if (link.indexOf('xsteacher') !== -1) {
      video.src = 'https://s.doumiao9.com/official/media/product-xsteacher-intro.mp4'
    } else {
      video.src = this.staticPath + link
    }
    // console.log(video)
    popup.style.display = 'block'
    setTimeout(() => {
      video.width = popup.offsetWidth / 2
      text.style.width = popup.offsetWidth / 2 + 'px'
      return video.play()
    },200)
  }
  videoClose () {
    window.scrollTo(0, this.scrollY)
    let popup = document.querySelector('.product-video-popup') as HTMLDivElement
    popup.style.display = 'none'
    let video = document.querySelector('.product-introduce-video') as HTMLVideoElement
    video.pause()
  }
  showPanel (name?: string) {
    console.log(name)
    if (name === undefined) { name = 'xingsuan' }
    let btnNavKetang = document.querySelector('.product-nav-ketang')
    let btnNavChuti = document.querySelector('.product-nav-chuti')
    let btnNavShansuan = document.querySelector('.product-nav-shansuan')
    let btnNavTeacher = document.querySelector('.product-nav-teacher')
    let btnNavSiwei = document.querySelector('.product-nav-siwei')
    let btnNavManage = document.querySelector('.product-nav-manage')
    let btnNavXingsuan = document.querySelector('.product-nav-xingsuan')
    let btnNavXsteacher = document.querySelector('.product-nav-xsteacher')
    let panelKetang = document.querySelector('.panel-ketang')
    let panelChuti = document.querySelector('.panel-chuti')
    let panelShansuan = document.querySelector('.panel-shansuan')
    let panelTeacher = document.querySelector('.panel-teacher')
    let panelSiwei = document.querySelector('.panel-siwei')
    let panelManage = document.querySelector('.panel-manage')
    let panelXingsuan = document.querySelector('.panel-xingsuan')
    let panelXsteacher = document.querySelector('.panel-xsteacher')
    let show = btnNavKetang
    let btnOn = btnNavChuti
    if (name === 'ketang') {
      show = panelKetang
      btnOn = btnNavKetang
    } else if (name === 'chuti') {
      show = panelChuti
      btnOn = btnNavChuti
    } else if (name === 'shansuan') {
      show = panelShansuan
      btnOn = btnNavShansuan
    } else if (name === 'teacher') {
      show = panelTeacher
      btnOn = btnNavTeacher
    } else if (name === 'siwei') {
      show = panelSiwei
      btnOn = btnNavSiwei
    } else if (name === 'manage') {
      show = panelManage
      btnOn = btnNavManage
    } else if (name === 'xingsuan') {
      show = panelXingsuan
      btnOn = btnNavXingsuan
    } else if (name === 'xsteacher') {
      show = panelXsteacher
      btnOn = btnNavXsteacher
    }
    if (panelKetang && panelKetang !== show) {
      if (btnNavKetang) { btnNavKetang.classList.remove('on') }
      panelKetang.classList.remove('show')
      this.panelVideoPause(panelKetang)
    }
    if (panelChuti && panelChuti !== show) {
      if (btnNavChuti) { btnNavChuti.classList.remove('on') }
      panelChuti.classList.remove('show')
      this.panelVideoPause(panelChuti)
    }
    if (panelShansuan && panelShansuan !== show) {
      if (btnNavShansuan) { btnNavShansuan.classList.remove('on') }
      panelShansuan.classList.remove('show')
      this.panelVideoPause(panelShansuan)
    }
    if (panelTeacher && panelTeacher !== show) {
      if (btnNavTeacher) { btnNavTeacher.classList.remove('on') }
      panelTeacher.classList.remove('show')
      this.panelVideoPause(panelTeacher)
    }
    if (panelSiwei && btnNavSiwei !== show) {
      if (btnNavSiwei) { btnNavSiwei.classList.remove('on') }
      panelSiwei.classList.remove('show')
      this.panelVideoPause(panelSiwei)
    }
    if (panelManage && btnNavManage !== show) {
      if (btnNavManage) { btnNavManage.classList.remove('on') }
      panelManage.classList.remove('show')
      this.panelVideoPause(panelManage)
    }
    if (panelXingsuan && panelXingsuan !== show) {
      if (btnNavXingsuan) { btnNavXingsuan.classList.remove('on') }
      panelXingsuan.classList.remove('show')
      this.panelVideoPause(panelXingsuan)
    }
    if (panelXsteacher && panelXsteacher !== show) {
      if (btnNavXsteacher) { btnNavXsteacher.classList.remove('on') }
      panelXsteacher.classList.remove('show')
      this.panelVideoPause(panelXsteacher)
    }
    if (btnOn) { btnOn.classList.add('on') }
    if (show) { show.classList.add('show') }
  }
  panelVideoPause (ele: Element) {
    let videos = ele.querySelectorAll('.product-introduce-video')
    let len = videos.length
    for (let i = 0; i < len; i++) {
      let video = videos[i] as HTMLVideoElement
      video.pause()
    }
  }
  mounted () {
    let anchor = null
    if (this.$route.query.anchor === 'ketang') {
      anchor = document.querySelector('.product-ketang')
    } else if (this.$route.query.anchor === 'chuti') {
      anchor = document.querySelector('.product-chuti')
    } else if (this.$route.query.anchor === 'shansuan') {
      anchor = document.querySelector('.product-shansuan')
    } else if (this.$route.query.anchor === 'teacher') {
      anchor = document.querySelector('.product-teacher')
    } else if (this.$route.query.anchor === 'siwei') {
      anchor = document.querySelector('.product-siwei')
    } else if (this.$route.query.anchor === 'manage') {
      anchor = document.querySelector('.product-manage')
    } else if (this.$route.query.anchor === 'xingsuan') {
      anchor = document.querySelector('.product-xingsuan')
    } else if (this.$route.query.anchor === 'xsteacher') {
      anchor = document.querySelector('.product-xsteacher')
    }
    if (anchor) {
      document.documentElement.scrollTop = (anchor as HTMLElement).offsetTop
      document.body.scrollTop = (anchor as HTMLElement).offsetTop
    }
    Lib.dispatchEvent(document, 'custom-render-trigger')
    let btnNavKetang = document.querySelector('.product-nav-ketang')
    let btnNavChuti = document.querySelector('.product-nav-chuti')

    let btnNavXingsuan = document.querySelector('.product-nav-xingsuan')
    let btnNavXsteacher = document.querySelector('.product-nav-xsteacher')
    let btnClose = document.querySelector('.video-popup-close-box')

    let btnVideoXingsuan = document.querySelector('.product-video-xingsuan') as Element
    let btnVideoXsteacher = document.querySelector('.product-video-xsteacher') as Element

    let videoXingsuanCon = btnVideoXingsuan.querySelectorAll('.video-content-box')
    let videoXsteacherCon = btnVideoXsteacher.querySelectorAll('.video-content-box')
    if (btnClose) {
      btnClose.addEventListener('click', () => {
        this.videoClose()
        if (sessionStorage.clickcount) {
          // 判断是否是用户主动关闭声音，是就不播放
          if (this.audio && sessionStorage.appMusicState === 'false') {
            this.audio.play().catch()
            this.audio.currentTime = sessionStorage.clickcount
            if (this.component)this.component.classList.remove('paused')
          }
        }
      })
    }

    if (videoXingsuanCon) {
      videoXingsuanCon.forEach((v, i) => {
        let img = v.querySelector('.video-content-img') as HTMLImageElement
        let alt = img.alt
        v.addEventListener('click', () => {
          // this.videoPlay(linkArr[i])
          console.log(alt)
          if (alt) {
            this.videoPlay('/media/xingsuan-' + alt + '.mp4')
          }
        })
      })
    }
    if (videoXsteacherCon) {
      videoXsteacherCon.forEach((v, i) => {
        let img = v.querySelector('.video-content-img') as HTMLImageElement
        let alt = img.alt
        v.addEventListener('click', () => {
          // this.videoPlay(linkArr[i])
          console.log(alt)
          if (alt) {
            this.videoPlay('/media/xsteacher-' + alt + '.mp4')
          }
        })
      })
    }
    if (btnNavKetang) {
      btnNavKetang.addEventListener('click', () => {
        this.showPanel('ketang')
      })
    }
    if (btnNavChuti) {
      btnNavChuti.addEventListener('click', () => {
        this.showPanel('chuti')
      })
    }

    if (btnNavXingsuan) {
      btnNavXingsuan.addEventListener('click', () => {
        this.showPanel('xingsuan')
      })
    }
    if (btnNavXsteacher) {
      btnNavXsteacher.addEventListener('click', () => {
        this.showPanel('xsteacher')
      })
    }
    this.showPanel()
  }
}
